<template>
    <div class="container">
       <div class="headline">Votre compte partenaire</div>
       <div class="subline">Télécharger la dernière version de vos applications ou contactez le support</div>

       <div class="row">
           <div class="col-4">
               <div class="card">
                   <div class="brand">{{company}}</div>
                   <div class="">{{first_name}} {{name}}</div>
                   <div class="">{{username}}</div>
                   <img v-bind:src="{logo}" class="img-fluid partLogo" alt="">
                   <div class="row mb-3 logoutBtn">
                       <div class="col-1">
                           <i class="fas fa-power-off"></i>
                       </div>
                       <div v-on:click="logout()" class="col">  Déconnexion</div>
                   </div>

               </div>
               <div class="card">
                   <div class="headline">Contactez AgriVitech</div>
                    <!-- <a href="https://bazam.atlassian.net/servicedesk/customer/portal/2" class="btn btn-primary mb-3" target="blank"><i class="fas fa-bug mr-2"></i> Ouvrir un ticket</a> -->
                   <router-link class="btn btn-primary" to="/contact"><i class="fas fa-envelope-open mr-2"></i> Formulaire de contact</router-link>
                   <router-link class="btn btn-primary mt-3" to="/contact-demo"><i class="fas fa-calendar-plus mr-2"></i> Réservez rendez-vous</router-link>
               </div>
           </div>
           <div class="col">
               <div v-if="!apps" class="card">
                   <div class="headline text-center">Votre compte est en cours d'activation</div>
                   <div class="subline text-center">Vous recevrez une confirmation par email</div>
                   <img v-bind:src="require(`@/assets/img/illustrations/wait.png`)" class="img-fluid imgWait" alt="">
               </div>
               <div v-if="apps" class="card">
                   <div class="headline">Application mobile Fleet <img src="@/assets/img/Fleet.png"  class="logoClient" alt="Fleet">  </div>
                   <div>Les dernières release de l'application :</div>
                   <ul class="list-group list-group-flush">
                        <li class="list-group-item headline">
                            <div class="row">
                                <div class="col-2">Version</div>
                                <div class="col-3">Date</div>
                                <div class="col">Commentaire</div>
                                <div class="col-3">Liens</div>
                            </div>
                        </li>
                        <li v-for="app in apps" v-bind:key="app" v-bind:class="{'out': app.active === 0}" class="list-group-item">
                            <div class="row">
                                <div class="col-2">{{app.version}}</div>
                                <div class="col-3">{{app.date_publication}}</div>
                                <div class="col">{{app.comment}}</div>
                                <div v-if="app.active" class="col-3"><a :href="`https://${app.play_store_link}`" target="blank"><i class="fab fa-google-play mr-2"></i></a> <a :href="`https://${app.app_store_link}`" target="blank"><i class="fab fa-app-store mr-2"></i></a> <a href="../assets/apks/Fleet.apk"><i class="fab fa-android"></i></a></div>
                            </div>
                        </li>
                    </ul>
               </div>

       
                <div v-for="demo in demos" v-bind:key="demo" class="card">
                   <div class="headline">Votre accès démo {{demo.app_name}} 
                       <img v-if="demo.app_name == 'Bourse Echange'" v-bind:src="require(`@/assets/img/BourseEchange.png`)"  class="logoClient" alt="{{demo.app_name}}">
                       <img v-if="demo.app_name == 'DigitAppro'" v-bind:src="require(`@/assets/img/DigitAppro.png`)"  class="logoClient" alt="{{demo.app_name}}">
                    </div>
                    

                   <div class="row">
                       <div class="col">
                           Utilisateur : {{demo.login}} 
                       </div>
                       <div class="col">
                           Mot de passe : {{demo.password}} 
                       </div>
                   </div>

               </div>
     
           </div>
       </div>
   </div>
</template>



<script>
import { store } from '@/router/store'
import router from '@/router/router'
export default {
    name: 'PartHome',
  data() {
    return {
      secretMessage: '',
      username: store.getters.getUser.username,
      company: store.getters.getUser.company,
      first_name: store.getters.getUser.first_name,
      name: store.getters.getUser.name,
      logo: store.getters.getUser.logo,
      demos: store.getters.getUser.demos,
      apps: store.getters.getUser.apps,
      loginBE: '',
      mdpBE:'',
      loginDAP: '',
      mdpDAP:'',
      hasError:false,
      result:''
    };
  },
  methods: {
    logout() {
      store.dispatch('logout');
      router.push('/private');
    }
  },
  beforeUpdate() {
    this.demos = []
    this.apps = []
  },
  updated() {

  }
};
</script>

<style lang="scss" scoped>


a{
    color: var(--mainBlue);
    font-weight: 500;
    &:hover{
        color: var(--mainGreen);
    }
}

.brand{
    font-size: 40px;
    font-weight: 700;
    text-transform: capitalize;
}

.logoutBtn{
    cursor: pointer;
    margin-top: 20px;
    padding-top: 20px;
    border-top: solid 1px #f0f0f0;
    &:hover{
        color: var(--mainGreen);
    }
}

.imgWait{
    max-width: 300px;
    margin-right: auto;
    margin-left: auto;
}

.headline{
    font-size: 30px;
    margin-top: 50px;
    font-weight: 700;
}
.subline{
    font-size: 20px;
    color: var(--mainGreen);
    margin-bottom: 50px;
}

.card{
    border-radius: 10px;
    -webkit-box-shadow: 6px 9px 20px 0px rgba(19, 34, 81, 0.17);
    box-shadow: 6px 9px 20px 0px rgba(19, 34, 81, 0.17);
    border: none;
    padding: 15px;
    margin-bottom: 25px;
    .headline{
        font-size: 17px;
        margin-top: 0;
        margin-bottom: 10px;
    }
    .logoClient {
        max-height: 70px;
        position: absolute;
        right: 15px;
        top: 0px;
    }
    .partLogo{
        max-width: 200px;
    }
    .logoApp{
        max-width: 50px;
    }
    .list-group{
        .headline{
            font-size: 13px;
            font-weight: 700;
        }
        &.out{
            color: gray;
        }
    }
    .list-group{
        .headline{
            font-size: 13px;
            font-weight: 700;
        }
        .out{
            color: gray;
            cursor: default;
        }
    }
}
</style>